import React from 'react'
import { FormikProps, getIn } from 'formik'
import { RadioGroup } from 'bs-unified-ui'

interface RadioProps {
  form: FormikProps<any>
  field: {
    name: string
    value: any
  }
  onChange?: (value: any) => void
  disabled?: boolean
  options?: any[]
  label?: string
  [key: string]: any
}

const Radio: React.FC<RadioProps> = ({
  form,
  field,
  onChange = () => {},
  disabled = false,
  ...props
}) => (
  <RadioGroup
    inputProps={{
      error: getIn(form.touched, field.name) && getIn(form.errors, field.name),
      helperText:
        getIn(form.touched, field.name) && getIn(form.errors, field.name),
    }}
    {...field}
    onChange={(e: any) => {
      form.setFieldValue(field.name, e.target.value)
      onChange(e.target.value)
    }}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

export default Radio
